import { render, staticRenderFns } from "./CreateConsentCancerForm.vue?vue&type=template&id=2303f840&scoped=true"
import script from "./CreateConsentCancerForm.vue?vue&type=script&lang=js"
export * from "./CreateConsentCancerForm.vue?vue&type=script&lang=js"
import style0 from "./CreateConsentCancerForm.vue?vue&type=style&index=0&id=2303f840&prod&lang=scss&scoped=true"
import style1 from "./CreateConsentCancerForm.vue?vue&type=style&index=1&id=2303f840&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2303f840",
  null
  
)

export default component.exports